"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("../List"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This is a stepper component that is used to guide users through a series of sequential steps, providing a clear start and end point. It helps users understand their current position in the process and anticipate upcoming actions. The stepper component should accept a list of Step components for the steps.
 */

const Stepper = _ref => {
  let {
    variant = "vertical",
    steps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    items: steps,
    inline: variant === "horizontal",
    className: (0, _classnames.default)({
      "stepper-horizontal": variant === "horizontal",
      "stepper-vertical": variant === "vertical"
    })
  });
};
Stepper.propTypes = {
  variant: _propTypes.default.oneOf(["horizontal", "vertical"]),
  steps: _propTypes.default.arrayOf(_propTypes.default.element).isRequired
};
var _default = exports.default = Stepper;